export const ProjectData = [
  {
    id: 1,
    title: "Bursapediary Donation App",
    about:
      "Bursapediary makes it easy and safe for you to give support to local projects anywhere in the world, while providing nonprofits and individuals with the tools, training, and support they need to thrive.",
    tags: [
      "Reactjs",
      "Redux",
      "JavaScript",
      "TailwindCSS",
      "Formik",
      "EmailJS",
      "Mapbox",
      "API",
    ],
    github: "https://github.com/ReCoded-Org/capstone-turkey-react-bursapediary",
    image: require("../../assets/project-image/bursapediary.jpg").default,
  },
  {
    id: 2,
    title: "React Planet Movie 📽",
    about:
      "You can reach out to the trending movies, watch trailer, filter them with your favorite categories, view the details such as score, cast and also search for specific movie or tv series.",
    tags: [
      "Reactjs",
      "Material UI",
      "React Router",
      "Flexbox",
      "The Movie Database API",
    ],
    demo: "https://planetmovie.netlify.app/",
    github: "https://github.com/OzerOzturk/React-Planet-Movie",
    image: require("../../assets/project-image/planetmovie.jpg").default,
  },
  {
    id: 3,
    title: "ÇicekSepeti Clone",
    about:
      "This e-commerce project includes shopping cart function and also search filter function for your items. It's a completely responsive design.",
    tags: ["Reactjs", "Context API", "Sass", "Flexbox"],
    demo: "https://ciceksepeti-react.netlify.app/",
    github: "https://github.com/OzerOzturk/ciceksepeti-frontend-case",
    image: require("../../assets/project-image/ciceksepeti.png").default,
  },

  {
    id: 4,
    title: "MERN Map Pin App 📍",
    about:
      "Provide you with information on places you're looking for. You can register and then login to pin your location with your comments and ratings.",
    tags: ["MongoDB", "Expressjs", "Reactjs", "Nodejs", "Mapbox"],
    github: "https://github.com/OzerOzturk/MERN-Map-Pin-App",
    image: require("../../assets/project-image/mappin.jpg").default,
  },
  {
    id: 5,
    title: "Netflix Clone 🍿",
    about:
      "Sign in and signup with Firebase Authentication, searching movie and TV series and playing intro videos of products.",
    tags: [
      "Reactjs",
      "Context API",
      "React Router",
      "Styled Component",
      "Firebase Authentication",
    ],
    demo: "https://netflix-clone-reactt.web.app/",
    github: "https://github.com/OzerOzturk/Netflix-Clone",
    image: require("../../assets/project-image/netflix.jpg").default,
  },

  {
    id: 6,
    title: "Home Finder 🏠",
    about:
      "Home finder shows us properties that are available for sale in the United States. When searching for your next home, you can sort by newness, price, and height.",
    tags: ["Nextjs", "TailwindCSS", "React Router", "Realty API"],
    github: "https://github.com/OzerOzturk/nextjs-real-estate",
    image: require("../../assets/project-image/homefinder.png").default,
  },
];
